import { ReactNode } from 'react';
import { useDarkMode } from '../../context/DarkModeContext';
import LoginBrandPanel from './LoginBrandPanel';
import './LoginLayout.css';

interface LoginLayoutProps {
  children: ReactNode;
  noCard?: boolean;
}

function LoginLayout({ children, noCard = false }: LoginLayoutProps) {
  const versionTag = (window as any).APP_VERSION;
  const { isDarkMode, colors: dm } = useDarkMode();

  return (
    <div className="flex h-screen w-screen overflow-hidden">
      {/* ── Brand panel (desktop only) ───────────────────────────────────── */}
      <LoginBrandPanel className="flex-[5]" />

      {/* ── Form panel ──────────────────────────────────────────────────── */}
      <div className="flex flex-col items-center justify-center flex-[7] p-6 overflow-y-auto" style={{ background: isDarkMode ? dm?.BG : '#f9fafb' }}>
        <div
          className={`login-card w-full max-w-md p-8${noCard ? '' : ' rounded-2xl'}`}
          style={
            noCard
              ? undefined
              : {
                  background: isDarkMode ? dm?.SURFACE : '#ffffff',
                  boxShadow: isDarkMode ? '0 2px 24px rgba(0,0,0,0.4)' : '0 4px 24px rgba(0,0,0,0.08)',
                  // Establishes a containing block for the form's fixed-position loading
                  // overlay (see FormComponent), so it covers just this card instead of
                  // the full viewport.
                  position: 'relative',
                  overflow: 'hidden',
                  transform: 'translateZ(0)',
                }
          }
        >
          {/* Logo shown on mobile (brand panel is hidden) */}
          {/* <div className="flex justify-center mb-6 md:hidden">
            <Logo width={64} height={64} />
          </div> */}
          {children}
        </div>
        {versionTag ? <p className="mt-4 text-xs text-gray-400">{versionTag}</p> : null}
      </div>
    </div>
  );
}

export default LoginLayout;
